export const contacts = [
    {
        id: "1",
        name: "Seb",
        mail: "production@lesrichesclaires.be",
        tel: '0493/50 65 59'
    },
    {
        id: "2",
        name: "Barto",
        mail: "contact@lesrichesclaires.be"
    },
]